// Does a frontend search on an array of strings
export class FETextSearcher<T> {
    // Expects to be passed a list to search. In the future, we might build local indexes to speed up searching
    // if we implement a better algorithm like trigrams. For now, we're using "includes".
    constructor(private list: T[], private getItemValue: (item: T) => string) {}

    public search = (query: string): T[] => {
        const queryLower = query.toLowerCase();

        return this.list.filter(item => {
            // Get the item's value, but make sure it's a string before we start trying to manipulate it.
            let value = this.getItemValue(item);
            if (!value || !value.includes) return false;

            // Note: this isn't very performant because we're reconverting everything to lowercase.
            // But, it's fine for our current use case.
            return value.toLowerCase().includes(queryLower);
        });
    }
}